// helpers/timeAgo.js
/**
 * formatRelativeTime
 * Returns a short relative time string for a given date or ISO string.
 * Examples: "just now", "5 sec", "1 minute", "3 hours", "2 days", "Jun 3, 2026"
 */
export function formatRelativeTime(dateInput) {
  try {
    if (!dateInput) return "";
    const then = new Date(dateInput).getTime();
    if (isNaN(then)) return "";
    const now = Date.now();
    const diff = now - then;
    const sec = Math.floor(diff / 1000);
    if (sec < 1) return "just now";
    if (sec < 60) return `${sec} sec${sec > 1 ? 's' : ''}`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min} minute${min > 1 ? 's' : ''}`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} hour${hr > 1 ? 's' : ''}`;
    const days = Math.floor(hr / 24);
    if (days < 7) return `${days} day${days > 1 ? 's' : ''}`;
    // Older than a week: show formatted date
    const d = new Date(dateInput);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch (e) {
    return "";
  }
}

export default formatRelativeTime;
